import { Link } from '@inertiajs/react';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface AdminBreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function AdminBreadcrumb({ items }: AdminBreadcrumbProps) {
  if (items.length === 0) return null;

  return (
    <nav className="mb-4 text-sm text-base-content/60">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => (
          <li
            key={`${item.label}-${index}`}
            className="flex items-center gap-2"
          >
            {index > 0 && <span className="text-base-content/40">/</span>}
            {item.href ? (
              <Link
                href={item.href}
                className="hover:text-base-content transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-base-content font-medium">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
